import { checkDefined } from 'faro-common-model';
export function toIntraDayConfig(config) {
    checkDefined(config.groupbysampletypes, 'IntraDayConfig', 'groupbysampletypes');
    return {
        groupbysampletypes: config.groupbysampletypes,
    };
}
//# sourceMappingURL=intraday-config.js.map